import React from 'react';
import ReactTooltip from 'react-tooltip';
import InfoIcon from 'material-ui/svg-icons/action/info';

export const TooltipWrapper = ({ text }) => (
    <React.Fragment>
        <span 
            data-tip={text}
            style={{
                position: 'absolute', pointerEvents: 'all', top: 1, right: 1, 
            }}
        >
            <InfoIcon style={{ height: '1em', width: '1em', color: '#969696' }} />
        </span>
        <ReactTooltip type="light" border offset={15} />
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./app/components/Hires/utils.jsx